// extracted by mini-css-extract-plugin
export default {"stateLabel":"HeaderState-module__stateLabel--Na0HJ","duplicateIssueLink":"HeaderState-module__duplicateIssueLink--gPcio"};